/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TopJobDurationEnum = 'Unlimited' | 'Days07' | 'Days14' | 'Days21';

export const TopJobDurationEnum = {
    Unlimited: 'Unlimited' as TopJobDurationEnum,
    Days07: 'Days07' as TopJobDurationEnum,
    Days14: 'Days14' as TopJobDurationEnum,
    Days21: 'Days21' as TopJobDurationEnum
};

